module.exports = __webpack_public_path__ + "static/img/ksy.ab0600a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ksy.png
// module id = bsHz
// module chunks = 3